import { render, staticRenderFns } from "./buy-record.vue?vue&type=template&id=686ed4c6&scoped=true&"
import script from "./buy-record.vue?vue&type=script&lang=js&"
export * from "./buy-record.vue?vue&type=script&lang=js&"
import style0 from "./buy-record.vue?vue&type=style&index=0&id=686ed4c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ed4c6",
  null
  
)

export default component.exports